import { useState, useEffect } from 'react'
import trackError from '@helpers/trackError'
import contentFul from '@api/contentful'
import { getValueFromObject } from '@helpers/utils'
import { useRouter } from 'next/router'

function useContentfulImage(imageId: string) {
  const [image, setImage] = useState<string>('')
  const { query } = useRouter()
  const { preview } = query

  useEffect(() => {
    const getContentfulImage = async () => {
      try {
        const response = await contentFul.getAsset(imageId, preview === 'true')
        const imageUrl = getValueFromObject(response, 'fields.file.url', '')
        setImage(imageUrl)
      } catch (error) {
        trackError(new Error(`Failed to get Contentful image - ${imageId}`))
      }
    }
    getContentfulImage()
  }, [imageId])

  return image
}

export default useContentfulImage
